import { createContext, useContext } from 'react'

import { TEACHER_CLASSES, type TeacherClass } from '../data/class-teacher-mock'

interface SelectedClassContextValue {
  selectedClass: TeacherClass
  setSelectedClass: (cls: TeacherClass) => void
}

export const SelectedClassContext = createContext<SelectedClassContextValue>({
  selectedClass: TEACHER_CLASSES[0]!,
  setSelectedClass: () => {},
})

export function useSelectedClass() {
  return useContext(SelectedClassContext)
}
